import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07875e90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon" }
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  __name: 'icon-check',
  props: {
    size: {
      type: Number,
      default: 24
    }
  },
  setup(__props) {

  //eslint-disable-next-line
  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      width: __props.size,
      height: __props.size,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_4, 8, _hoisted_2))
  ]))
}
}

})